import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "madrid-route__directions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("h1", null, "Información útil", -1)),
    _createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("span", null, "INICIO", -1)),
      _createElementVNode("pre", null, _toDisplayString(_ctx.directions.init.init), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.init.metro)})
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("p", null, "METRO", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.init.metro), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.init.autobus)})
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "AUTOBÚS", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.init.autobus), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.init.tren)})
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "TREN", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.init.tren), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.init.bicimad)})
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("p", null, "BICIMAD", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.init.bicimad), 1)
        ], 2)
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[9] || (_cache[9] = _createElementVNode("span", null, "FINAL", -1)),
      _createElementVNode("pre", null, _toDisplayString(_ctx.directions.final.final), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.final.metro)})
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "METRO", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.final.metro), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.final.autobus)})
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("p", null, "AUTOBÚS", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.final.autobus), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.final.tren)})
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "TREN", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.final.tren), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({'ox-hidden': _ctx.isDisabled(_ctx.directions.final.bicimad)})
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("p", null, "BICIMAD", -1)),
          _createElementVNode("pre", null, _toDisplayString(_ctx.directions.final.bicimad), 1)
        ], 2)
      ])
    ])
  ]))
}